"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hotspot = require("../../hotspot.defaultConfigs");

var _Swirl = require("./Swirl.styles");

var _svgElements = require("../../components/svg-elements");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Swirl = function Swirl(_ref) {
  var config = _ref.config,
      iconPosition = _ref.iconPosition,
      onClick = _ref.onClick,
      previewHoverState = _ref.previewHoverState,
      disableHover = _ref.disableHover,
      name = _ref.name;
  var swirlConfig = config || _hotspot.swirl;
  var primaryColor = swirlConfig.primaryColor,
      secondaryColor = swirlConfig.secondaryColor;
  var ariaLabel = "".concat(name, " hotspot");
  return _react.default.createElement(_Swirl.ClickableAreaStyled, {
    onClick: onClick,
    previewHoverState: previewHoverState,
    secondaryColor: secondaryColor,
    disableHover: disableHover,
    "aria-label": ariaLabel
  }, iconPosition && _react.default.createElement(_Swirl.SwirlStyled, {
    config: swirlConfig,
    iconPosition: iconPosition
  }, _react.default.createElement(_Swirl.InnerSwirl, {
    viewBox: "0 0 92 92",
    height: "100%",
    width: "100%",
    preserveAspectRatio: "xMinYMin"
  }, _react.default.createElement(_svgElements.Path, {
    strokeWidth: "8",
    stroke: primaryColor,
    fill: "transparent",
    strokeOpacity: "1",
    d: "M45.917,0.5c25.067,0 45.418,20.351 45.418,45.417c0,25.067 -20.351,45.418 -45.418,45.418c-25.066,0 -45.417,-20.351 -45.417,-45.418c0,-25.066 20.351,-45.417 45.417,-45.417Zm0,0c25.067,0 45.418,20.351 45.418,45.417c0,25.067 -20.351,45.418 -45.418,45.418c-25.066,0 -45.417,-20.351 -45.417,-45.418c0,-25.066 20.351,-45.417 45.417,-45.417Z"
  })), _react.default.createElement(_Swirl.OuterSwirl, {
    viewBox: "0 0 92 92",
    preserveAspectRatio: "xMinYMin"
  }, _react.default.createElement(_svgElements.Path, {
    strokeWidth: "6",
    stroke: primaryColor,
    fill: "transparent",
    strokeOpacity: "1",
    d: "M45.917,0.5c25.067,0 45.418,20.351 45.418,45.417c0,25.067 -20.351,45.418 -45.418,45.418c-25.066,0 -45.417,-20.351 -45.417,-45.418c0,-25.066 20.351,-45.417 45.417,-45.417Zm0,0c25.067,0 45.418,20.351 45.418,45.417c0,25.067 -20.351,45.418 -45.418,45.418c-25.066,0 -45.417,-20.351 -45.417,-45.418c0,-25.066 20.351,-45.417 45.417,-45.417Z"
  })), _react.default.createElement(_Swirl.Center, null)));
};

var _default = Swirl;
exports.default = _default;